import { render, staticRenderFns } from "./OptionPropertyAttorneysPrimaryWorkTogetherOther.vue?vue&type=template&id=e2f88616"
import script from "./OptionPropertyAttorneysPrimaryWorkTogetherOther.vue?vue&type=script&lang=js"
export * from "./OptionPropertyAttorneysPrimaryWorkTogetherOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports